import { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import Button from 'src/components/Button';
import ExternalLink from 'src/components/ExternalLink';
import { ModalFooter } from 'src/components/ModalLayout';
import { ErrorCode, Wrapper as WrapperBase } from 'src/components/Payments/Failure/style';
import useSelectedTab from 'src/hooks/useSelectedTab';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Wrapper = styled(WrapperBase)`
  padding: 60px 0;
  flex-grow: 1;
`;
const Link = styled(ExternalLink)`
  text-decoration: none;
`;
const EmptyGemProductsImage = styled.img``;
const EmptyProducts: FC = () => {
  const {
    t
  } = useTranslation();
  const {
    selectedTab
  } = useSelectedTab();
  const handleClickAppLink = () => [pushEvent({
    eventType: EVENT_TYPE.WEB2APP,
    eventName: EVENT_NAME.ANYWHERE__CLICK_TO_APP_BTN,
    eventParams: {
      action_category: 'click',
      tab: selectedTab.name,
      page: 'main',
      target: 'to_app_btn',
      button_type: 'universal',
      referrer: 'shop'
    }
  })];
  return <Container data-sentry-element="Container" data-sentry-component="EmptyProducts" data-sentry-source-file="EmptyProducts.tsx">
      <Wrapper data-sentry-element="Wrapper" data-sentry-source-file="EmptyProducts.tsx">
        <EmptyGemProductsImage src='/images/shop/emptyGemProducts.svg' alt='empty-gem-products' data-sentry-element="EmptyGemProductsImage" data-sentry-source-file="EmptyProducts.tsx" />
        <ErrorCode data-sentry-element="ErrorCode" data-sentry-source-file="EmptyProducts.tsx">{t('shop_empty_package')}</ErrorCode>
      </Wrapper>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="EmptyProducts.tsx">
        <Link href='https://azarlive.onelink.me/fHTc/o973yvcc' onClick={handleClickAppLink} data-sentry-element="Link" data-sentry-source-file="EmptyProducts.tsx">
          <Button id='gem-products-empty' data-sentry-element="Button" data-sentry-source-file="EmptyProducts.tsx">{t('buy_in_app')}</Button>
        </Link>
      </ModalFooter>
    </Container>;
};
export default EmptyProducts;